<toolbarVisit></toolbarVisit>

<mat-dialog-content class="contentVmsVisitDetail">

  <empusa-microapp-vms-visit-detail ></empusa-microapp-vms-visit-detail>

</mat-dialog-content>


